// TeamPicker — client-side filter for Layouts.team_picker_grid/1. Matches the
// typed text against "ABBR City Nickname"; hides empty divisions and
// conferences; Enter picks the only remaining team.

export function matchesTeam(key, query) {
  return query === "" || key.includes(query)
}

export default {
  mounted() {
    const root = this.el
    const input = root.querySelector("[data-team-search]")
    const empty = root.querySelector("[data-team-empty]")
    if (!input) return

    const apply = () => {
      const q = input.value.trim().toLowerCase()
      let visible = 0

      root.querySelectorAll("[data-division]").forEach((division) => {
        let n = 0
        division.querySelectorAll("[data-team]").forEach((cell) => {
          const show = matchesTeam(cell.dataset.team, q)
          cell.hidden = !show
          if (show) n++
        })
        division.hidden = n === 0
        visible += n
      })

      root.querySelectorAll("[data-conference]").forEach((conference) => {
        conference.hidden = !conference.querySelector("[data-division]:not([hidden])")
      })

      if (empty) empty.hidden = visible > 0
    }

    input.addEventListener("input", apply)
    input.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return
      const cells = Array.from(root.querySelectorAll("[data-team]:not([hidden])"))
      if (cells.length === 1) {
        e.preventDefault()
        cells[0].click()
      }
    })

    // Open clean next time
    const dialog = root.closest("dialog")
    if (dialog) {
      dialog.addEventListener("close", () => {
        input.value = ""
        apply()
      })
    }
  },
}
